<template>
  <b-button-group size="sm" class="ml-auto">
    <slot></slot>
  </b-button-group>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.btn-group {
  .btn {
    color: var(--gray-500) !important;
    background: transparent !important;
    border: none;
    background: #f3f7fa !important;

    &.active {
      color: inherit !important;
      background: white !important;
      border-radius: 0.35rem !important;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px !important;
    }
  }
}
</style>